import { AutogenModelTractor, AutogenRowTractor } from "./autogen/AutogenModelTractor";

export class ModelTractor extends AutogenModelTractor<RowTractor> {
	constructor() {
		super(RowTractor);
	}
}

export class RowTractor extends AutogenRowTractor {
}